if (!customElements.get('product-video-button')) {
  class ProductVideo extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        toggleHandler: '.js-toggle-video',
        content: '.product-video__content',
        productInformation: '.product-information',
        header: '.header__content',
        body: 'body',
        video: '.product-video__content  video',

        overflow: 'overflow-hidden',
        contentActiveClass: 'product-video__content--active',
        hiddenOpacityClass: 'opacity-hidden',
      };

      this.toggleHandlers = document.querySelectorAll(this.selectors.toggleHandler);

      this.toggleHandlers.forEach((handler) => {
        handler.addEventListener('click', this.toggleInformation.bind(this));
      });
    }

    toggleInformation(e) {
      e.preventDefault();

      const body = document.querySelector(this.selectors.body);
      const productInformation = document.querySelector(this.selectors.productInformation);
      const header = document.querySelector(this.selectors.header);
      const content = this.querySelector(this.selectors.content);
      const video = this.querySelector(this.selectors.video);

      if (content.classList.contains(this.selectors.contentActiveClass)) {
        body.classList.remove(this.selectors.overflow);
        content.classList.remove(this.selectors.contentActiveClass);
        productInformation.classList.remove(this.selectors.hiddenOpacityClass);
        header.classList.remove(this.selectors.hiddenOpacityClass);
        video.pause();
        video.currentTime = 0;
      } else {
        body.classList.add(this.selectors.overflow);
        content.classList.add(this.selectors.contentActiveClass);
        productInformation.classList.add(this.selectors.hiddenOpacityClass);
        header.classList.add(this.selectors.hiddenOpacityClass);
        video.play();
      }
    }
  }

  customElements.define('product-video-button', ProductVideo);
}
